module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main', {
    attrs: {
      "role": "primary"
    }
  }, [_c('div', {
    staticClass: "row expanded collapse"
  }, [_c('div', {
    staticClass: "small-12 large-6 column"
  }, [_c('div', {
    staticClass: "mxr-look",
    style: ({
      height: (_vm.sectionHeight + "px")
    })
  }, [(_vm.totalPrice !== '0.00') ? _c('div', {
    staticClass: "mxr-product-price"
  }, [_c('div', {
    staticClass: "st-price"
  }, [_c('div', {
    staticClass: "price-info"
  }), _vm._v(" "), _c('div', {
    staticClass: "pricetag"
  }, [_c('div', {
    staticClass: "price"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("getAmount")(_vm.totalPrice)) + "€\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "decimal"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("getCents")(_vm.totalPrice)) + "\n                ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mxr-look__large",
    style: ({
      background: ("url(" + (_vm.look.images.large) + ") center center / cover")
    })
  }, [_c('div', {
    staticClass: "mxr-look__large--hover",
    style: ({
      background: ("url(" + (_vm.look.images.platter) + ") center center / cover")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "mxr-look__title show-for-medium"
  }, [_c('h2', {
    directives: [{
      name: "colorize",
      rawName: "v-colorize",
      value: (_vm.look.hex_color),
      expression: "look.hex_color"
    }]
  }, [_vm._v("#" + _vm._s(_vm._f("padToTwo")(_vm.lookId)))])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 large-6 column"
  }, [_c('div', {
    staticClass: "mxr-look__scene--head"
  }, [(_vm.look.images.scenes) ? _c('img', {
    attrs: {
      "src": _vm.look.images.scenes[0],
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mxr-look__content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.look.designers_word) ? _c('div', {
    staticClass: "column small-10 medium-6"
  }, [_c('blockquote', {
    staticClass: "mxr-quote"
  }, [_c('p', [_vm._v("“" + _vm._s(_vm.look.designers_word) + "”")]), _vm._v(" "), _c('cite', [_c('strong', [_vm._v(_vm._s(_vm.look.designers_name))]), _vm._v(", " + _vm._s(_vm.look.designers_job))])])], 1) : _c('div', {
    staticClass: "column small-10 medium-6"
  }, [_c('blockquote', {
    staticClass: "mxr-quote"
  }, [_c('p', [_vm._v("Find your rythm, enjoy your run ! Chacun trouvera son rythme en fonction de ses capacités, chacun trouvera son style en fonction de ses envies et de ses émotions.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column medium-5 show-for-large"
  }, [_c('div', {
    staticClass: "mxr-product-count"
  }, [_c('div', {
    directives: [{
      name: "colorize",
      rawName: "v-colorize",
      value: (_vm.look.hex_color),
      expression: "look.hex_color"
    }],
    staticClass: "mxr-product-count__num"
  }, [_vm._v(_vm._s((_vm.products).length))]), _vm._v(" "), _c('div', {
    staticClass: "mxr-product-count__word"
  }, [_vm._v("Prodotti")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row collapse align-right"
  }, [_c('div', {
    staticClass: "small-12 large-9 column"
  }, [_c('div', {
    staticClass: "show-for-small hide-for-medium"
  }, [(_vm.look.images.scenes) ? _c('img', {
    attrs: {
      "src": _vm.look.images.platter,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mxr-look__scene--body"
  }, [(_vm.look.images.scenes) ? _c('img', {
    attrs: {
      "src": _vm.look.images.scenes[1],
      "alt": ""
    }
  }) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "mxr-look__products"
  }, [_c('nav', {
    staticClass: "carousel-nav"
  }, [_c('button', {
    staticClass: "button top show-for-large",
    on: {
      "click": _vm.scrollNavUp
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-chevron-up"
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-nav__inner"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "carousel-cell",
      on: {
        "click": function($event) {
          _vm.selectIndex($event, index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": product.openGraph.image,
        "alt": "",
        "width": "62"
      }
    })])
  })), _vm._v(" "), _c('button', {
    staticClass: "button bottom show-for-large",
    on: {
      "click": _vm.scrollNavDown
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-chevron-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mxr-look__slider__wrap"
  }, [_c('div', {
    staticClass: "mxr-product-price"
  }, [_c('div', {
    staticClass: "st-price"
  }, [_c('div', {
    staticClass: "price-info"
  }), _vm._v(" "), _c('div', {
    staticClass: "pricetag"
  }, [_c('div', {
    staticClass: "price"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("getAmount")(_vm.currentProdPrice)) + "€\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "decimal"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("getCents")(_vm.currentProdPrice)) + "\n                ")])])])]), _vm._v(" "), (_vm.products.length) ? _c('flickity', {
    ref: "looksProductSlider",
    staticClass: "mxr-look__slider",
    attrs: {
      "options": _vm.flickityOptions
    }
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "cell",
      attrs: {
        "data-product": product.productInfo.productId
      }
    }, [_c('product-pic', {
      key: product.productInfo.productId,
      attrs: {
        "product": product
      }
    })], 1)
  })) : _vm._e()], 1), _vm._v(" "), (_vm.products.length) ? _c('div', {
    staticClass: "mxr-look__decli"
  }, [_c('product-declination', {
    attrs: {
      "product": _vm.productFiltered[0]
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('product-add', {
    attrs: {
      "product": _vm.productFiltered[0]
    }
  })], 1)])])]), _vm._v(" "), _c('borders', {
    attrs: {
      "prevLabel": _vm.prevLabel,
      "showChevronDown": true,
      "nextLabel": _vm.nextLabel,
      "show-corners": false,
      "show-text": false,
      "show-dots": false
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mxr-look__scroll hide-for-medium"
  }, [_c('i', {
    staticClass: "zmdi zmdi-chevron-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-009f2a76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Look.vue
// module id = 451
// module chunks = 1